import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Link from '@mui/material/Link';

import { RouterLink } from 'src/routes/components';

const SEVERITIES = ['info', 'success', 'warning', 'error'];

/**
 * The banner's face, shared verbatim with the manager dialog's preview so what a superadmin
 * previews IS what users get — role targeting is honest (superadmins are targeted like everyone
 * else), so the preview is their only first-hand look at a banner aimed elsewhere.
 */
export default function AnnouncementAlert({ announcement, onClose, sx }) {
  return (
    <Alert
      severity={SEVERITIES.includes(announcement.variant) ? announcement.variant : 'info'}
      onClose={announcement.dismissible ? onClose : undefined}
      sx={{ alignItems: 'center', ...sx }}
    >
      <AlertTitle sx={{ mb: announcement.message ? 0.25 : 0 }}>{announcement.title}</AlertTitle>
      {announcement.message}
      {announcement.cta_path && (
        <Link
          component={RouterLink}
          href={announcement.cta_path}
          color="inherit"
          sx={{ ml: announcement.message ? 1 : 0, fontWeight: 600 }}
        >
          {announcement.cta_label}
        </Link>
      )}
    </Alert>
  );
}

AnnouncementAlert.propTypes = {
  announcement: PropTypes.object,
  onClose: PropTypes.func,
  sx: PropTypes.object,
};
